import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import type { Currency } from "../../data/BaseEntity";
import { Price } from "../../misc/price";
import type { SavedCalculationPriceValue } from "../calculationTypes";

interface Props {
  readonly price: SavedCalculationPriceValue;
  readonly currency: Currency;
  readonly numberOfPeople: number;
}

const ProductsTotalPrice: FC<Props> = ({ price, currency, numberOfPeople }) => {
  const totalPrice = Price.fromNullable(price);
  const priceWithCurrency = totalPrice.toDisplayValue(currency);
  const pricePerPerson = totalPrice.isPresent()
    ? `${totalPrice.divideBy(numberOfPeople).round().toDisplayValue(currency)}/os.`
    : undefined;
  return (
    <Stack
      sx={{
        alignItems: "center",
        justifyItems: "center",
      }}
    >
      <Typography variant="h6" data-testid="products-total-price">
        {priceWithCurrency}
      </Typography>
      {numberOfPeople && (
        <Typography variant="h6" data-testid="products-price-per-person">
          {pricePerPerson}
        </Typography>
      )}
    </Stack>
  );
};

export default ProductsTotalPrice;
